<agpr-dialog-container
    id="sourceCreateDialog"
    [heading]="'Sources.create'"
    (close)="cancel()"
>
    <div class="agpr-sourceCreateDialog-content">
        <div class="agpr-sourceCreateDialog-content-sources">
            <agpr-create-source-input
                [id]="'sourceCreateDialog_input'"
                (sourcesAdded)="addSources($event)"
                (sourceRemoved)="removeSource($event)"
            ></agpr-create-source-input>
        </div>
        <div class="agpr-sourceCreateDialog-content-divider"></div>
        <div
            class="agpr-sourceCreateDialog-content-groups"
            [ngClass]="{'agpr-sourceCreateDialog-content-groups--withChips': groupChips.length}"
        >
            <agpr-autocomplete
                [id]="'sourceCreateDialog_groups'"
                [suggestions]="sourceGroups$"
                [dropdown]="true"
                [multiSelection]="false"
                (itemSelected)="addGroupChip($event)"
                label="SourceGroups.selection.add"
                placeholder="SourceGroups.selection.add.placeholder"
                labelField="name"
                [forceClearAfterSelection]="true"
            ></agpr-autocomplete>
            <div
                *ngIf="groupChips.length"
                class="agpr-sourceCreateDialog-content-groups-chips"
            >
                <agpr-scroll-panel>
                    <ul>
                        <li
                            *ngFor="let chip of groupChips; let i = index"
                            [id]="'sourceCreateDialog_groups_chip_' + i"
                            class="agpr-chip"
                            [attr.aria-label]="chip.label"
                        >
                            <span
                                class="agpr-chip-label"
                            >
                                {{ chip.label }}
                            </span>
                            <button
                                [id]="'sourceCreateDialog_groups_chip_' + i + '_delete'"
                                class="agpr-chip-icon agpr-i-close"
                                agprTooltip="Common.forms.chips.delete"
                                [useTooltipAsAriaLabel]="false"
                                tooltipPosition="top"
                                (click)="removeGroupChip(chip)"
                                [attr.aria-label]="chip.label + ' ' + ('Common.forms.chips.delete' | localize)"
                            ></button>
                        </li>
                    </ul>
                </agpr-scroll-panel>
            </div>
        </div>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            label="Core.button.cancel"
            [style]="buttonStyle.secondary"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [disabled]="!sourceIds.length"
            [label]="groupChips.length ? 'add' : 'done'"
            [ariaLabel]="groupChips.length ? 'add' : 'done'"
            ariaDescribedBy="sourceCreateDialog_sourceText_error"
            [style]="buttonStyle.primary"
            (click)="done()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
